import { Translation, QRType } from '../types';

export const ja: Translation = {
  nav: {
    generator: '生成',
    scanner: 'スキャン',
    mobile: 'モバイルで試す',
    blog: 'ブログ',
    langSelect: '言語を選択',
  },
  pageTitles: {
    generator: '無料オンラインQRコード生成',
    scanner: 'オンラインQRコードスキャナー',
    textToQr: 'テキストをQRコードに変換',
    linkToQr: 'リンクをQRコードに変換',
  },
  pageMeta: {
    generator: {
      title:
        '無料QRコード生成 — QRコードをオンラインで作成（登録不要・透かしなし、PNG/SVG/PDF） | YesQRCode',
      description:
        'YesQRCodeで無料でQRコードを作成。URL、テキスト、Wi‑Fi、vCardなどに対応。高品質PNG/SVG/PDFでダウンロード。登録不要・ログイン不要・透かしなし — 速く、安全で、ずっと無料。',
      keywords: [
        'qrコード 生成',
        '無料 qrコード 生成',
        'qrコード 作成 オンライン',
        'qrコード メーカー',
        'qrコード png',
        'qrコード svg',
        'qrコード pdf',
        'wifi qrコード 生成',
        'vcard qrコード 生成',
        '登録不要 qr 生成',
      ],
    },
    scanner: {
      title:
        'オンラインQRコードスキャナー — 画像/カメラからスキャン（安全・登録不要） | YesQRCode',
      description:
        'QRコードとバーコードを無料でオンラインスキャン。画像をアップロードするかカメラを使用。処理はローカルで行われ、アップロードなし。安全・高速・登録不要で完全無料。',
      keywords: [
        'qrコード スキャナー',
        'qrコード スキャン オンライン',
        'オンライン qr リーダー',
        '画像 qr スキャン',
        'バーコード スキャン オンライン',
        '安全 qr スキャナー',
        'アップロードなし qr スキャン',
        '無料 qr スキャナー',
        'ブラウザ qr スキャナー',
        '登録不要 qr スキャナー',
      ],
    },
    textToQr: {
      title: 'テキスト→QR | メモをQRコードに変換',
      description:
        'テキスト、メモ、メッセージを共有できるQRコードに変換。ブランディング設定でPNG/SVG/PDFを書き出し。登録不要。',
      keywords: ['テキスト qr', 'テキスト qr 生成', 'メモ qrコード', 'メッセージ qr', 'qr 変換 オンライン', '無料 テキスト qr'],
    },
    linkToQr: {
      title: 'リンク→QR | URLをQRコードに変換',
      description:
        'WebサイトやキャンペーンURLを貼り付けて、印刷/デジタル向けのQRコードを即生成。色、ロゴ、高解像度ダウンロードに対応。',
      keywords: ['リンク qr', 'url qr 生成', 'サイト qr', 'リンク 用 qr', 'utm qrコード', 'qr pdf ダウンロード'],
    },
  },
  hero: {
    title: 'プライベートでブランド対応のQRコード — ずっと無料。',
    subtitle: '速く、プライベートで、どんなワークフローにも合うQRツール。',
    desc: 'アカウント不要・透かしなし・データアップロードなしで高品質QRを生成/スキャン。',
    ctaPrimary: 'QRコードを生成',
    ctaSecondary: 'モバイルで試す',
  },
  info: {
    helpTitle: 'ヘルプセンター',
    helpSubtitle: 'よくある質問 & サポート',
    contactTitle: 'お問い合わせ',
    contactSubtitle: 'お気軽にご連絡ください。',
    privacyTitle: 'プライバシーポリシー',
    termsTitle: '利用規約',
  },
  contactForm: {
    name: '名前',
    email: 'メール',
    message: 'メッセージ',
    send: '送信',
    orEmail: 'または次のアドレスへ直接メール:',
    sending: '送信中...',
    successTitle: '送信しました！',
    successMessage: 'お問い合わせありがとうございます。追ってご連絡します。',
    sendAnother: '別のメッセージを送る',
    errorMessage: '現在送信できません。support@yesqrcode.comへメールしてください。',
  },
  generator: {
    highlights: {
      title: 'プライベートでブランド対応のQRコード — ずっと無料。',
      subtitle: '速く、プライベートで、どんなワークフローにも合うQRツール。',
      items: [
        { title: 'プライバシー重視（端末内生成）', desc: 'QRはローカル生成。アップロード/追跡/保存なし。' },
        { title: '豊富な機能', desc: 'URL、Wi‑Fi、vCard、バーコード、ロゴ、グラデーション、フレーム。' },
        { title: 'モバイル最適化', desc: 'スマホやタッチ操作に最適化されたUI。' },
        { title: '永久無料（商用利用OK）', desc: 'アカウント不要、透かしなし、スキャン制限なし。' },
      ],
    },
    featureSuite: {
      title: 'プライバシー重視のQRコードスイート',
      subtitle: 'きれいでブランド対応の高品質QRを作るためのすべてを、ひとつに。',
      categories: [
        {
          title: '必要なQRタイプをすべて',
          body: 'URL、テキスト、Wi‑Fi、メール、電話、SMS、vCard、SNSリンク、YouTube、バーコード。期限のない静的コード。',
          items: [],
        },
        { title: 'ブランディング & デザイン', body: 'ロゴ安全、グラデーション、フレーム、形状、角、スキャン最適化レイアウト。', items: [] },
        { title: '出力 & 品質', body: '高品質PNG/SVG/PDF出力。印刷/デジタル向けプリセット。', items: [] },
        { title: 'グローバル & 使いやすさ', body: '多言語UI、モバイルファースト、オフライン向けワークフロー。', items: [] },
      ],
    },
    trust: {
      title: 'クリエイター、チーム、ブランドに選ばれています',
      subtitle:
        'YesQRCodeは軽量で予測可能、長期運用に安全 — アカウント不要、ベンダーロックインなし、隠れた制限なし。',
      items: ['すぐ使える', '静的コードで安心', '企業利用向け：クラウド処理なし', '資産全体で一貫したブランド'],
    },
    sectionContent: '内容',
    sectionColors: '色',
    sectionLogo: 'ロゴ',
    sectionFrame: 'フレーム',
    sectionDesign: 'デザイン',
    sectionCorrection: '誤り訂正',
    labelUrl: 'WebサイトURL',
    labelText: 'テキスト',
    labelSsid: 'ネットワーク名（SSID）',
    labelPassword: 'パスワード',
    labelEncryption: '暗号化',
    labelFgColor: '前景色',
    labelBgColor: '背景色',
    labelFrameText: 'フレーズ',
    labelFrameColor: 'フレーム色',
    placeholder: 'ここに内容を入力...',
    placeholders: {
      url: 'https://example.com',
      text: 'テキストを入力',
      email: 'you@email.com',
      subject: '件名',
      message: 'メッセージ...',
      phone: '+81 90-1234-5678',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: 'PNGをダウンロード',
    downloadSvg: 'SVGをダウンロード',
    generateButton: 'QRコードを生成',
    copy: 'SVGをコピー',
    uploadLogo: '画像をアップロード',
    preview: 'プレビュー',
    lowQuality: '低品質',
    highQuality: '高品質',
    foreverFree: '永久無料 • 登録不要 • 商用利用OK',
    barcodeWarning: 'バーコードではフレーム/ロゴなどの高度なデザインは利用できません。',
    barcodeColors: 'ただし、色は下でカスタマイズできます。',
    frameStyles: {
      none: 'なし',
      simple: 'シンプル',
      balloon: '吹き出し',
      box: 'ボックス',
      badge: 'バッジ',
      polaroid: 'ポラロイド',
      phone: 'スマホ',
      header: 'ヘッダー',
      corner: 'コーナー',
    },
    vCard: {
      firstName: '名',
      lastName: '姓',
      mobile: '携帯',
      phone: '電話',
      fax: 'FAX',
      email: 'メール',
      company: '会社',
      job: '役職',
      street: '住所',
      city: '市区町村',
      zip: '郵便番号',
      state: '都道府県',
      country: '国',
      website: 'Webサイト',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'テキスト',
      [QRType.EMAIL]: 'メール',
      [QRType.PHONE]: '電話',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi‑Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'バーコード',
    },
    guide: { title: 'カスタムQRコードの作り方', steps: [] },
    gettingStarted: {
      title: '使い方',
      steps: [
        {
          title: '内容を設定',
          text: '上部で種類（URL、テキスト、メール...）を選択します。選択後にオプションが表示されます。スキャン時に表示したい情報を入力し、印刷後は内容を変更できないため正確に入力してください。',
        },
        {
          title: 'デザインをカスタマイズ',
          text: '色や形を変えて個性的にできます。角や本体は個別にカスタム可能。ロゴはギャラリーから選択するか、画像をアップロードできます。',
        },
        {
          title: 'QRコードを生成',
          text: 'スライダーで解像度を調整します。「ダウンロード」をクリックして保存。必ずプレビューをスキャンして動作確認してください。',
        },
        {
          title: '画像をダウンロード',
          text: 'PNG/SVG/PDFでダウンロードできます。完全なデザイン付きのベクター形式が必要ならSVGを選択してください。ロゴ/一部デザイン設定はPNGとSVGで利用できます。',
        },
      ],
    },
    about: {
      title: '無料・プライバシー重視のQRコードスイート',
      subtitle:
        'アカウント不要・透かしなし・データアップロードなしで高品質QRを生成/スキャン。印刷、ブランディング、商用利用に最適化。',
      features: [
        'URL、テキスト、Wi‑Fi、vCard、SMS、バーコードに対応',
        '最大30%の誤り訂正でロゴにも強い',
        '形状/グラデーション/色/フレームをカスタム',
        '期限のない静的QRコード',
        'グローバル向け多言語UI',
      ],
      content: [
        { title: 'ロゴに強いQRコード', body: '最大30%の誤り訂正で、ロゴを重ねても読み取りやすさを保ちます。' },
        { title: '形状とフレーム', body: '角の形やグラデーション、フレームを選んでキャンペーンに合わせたデザインに。' },
        { title: '多様なコンテンツ', body: 'URL/テキスト/Wi‑Fi/vCard/SMS/バーコードを1か所で生成できます。' },
        { title: '長く使える静的コード', body: '期限切れやスキャン制限がなく、印刷物や長期運用に最適です。' },
      ],
    },
    faq: {
      title: 'よくある質問',
      items: [
        { q: 'QRコードとは？', a: 'QRはQuick Response Codeの略で、1994年にDenso Waveが開発した2次元コードです。' },
        { q: '商用利用できますか？', a: 'はい。この生成ツールで作成したQRコードは無料で、用途の制限なく利用できます。' },
        { q: '作成したQRコードは期限切れしますか？', a: 'いいえ。静的QRコードのため期限切れせず、ずっと動作します（作成後の内容編集はできません）。' },
        { q: 'スキャン回数の制限は？', a: '制限はありません。何度でもスキャンできます。' },
        { q: 'データを保存しますか？', a: 'ユーザーデータは保存・再利用しません。パフォーマンス最適化のため画像を最大24時間キャッシュする場合があります。' },
        { q: 'vCardで項目が正しく出ません', a: '一部のスキャナーが公式vCard仕様に準拠していない場合があります。別のスキャナーをお試しください。' },
        { q: 'QRが読み取れません', a: '入力内容の誤り、データ量、ロゴの影響、コントラスト不足などが原因です。URLの誤字や配色を確認してください。' },
        { q: '対応ブラウザは？', a: 'HTML5対応のモダンブラウザが必要です。Chrome/Firefox/Safari/Edge/Internet Explorer 11を公式サポートします。' },
      ],
    },
  },
  scanner: {
    title: 'QR & バーコードをスキャン',
    subtitle: 'カメラ、画像アップロード、貼り付けでQR/バーコードを即デコード。',
    cameraPermission: 'カメラへのアクセスが拒否されました。ブラウザ設定で許可してください。',
    result: '結果',
    copy: 'コピー',
    copied: 'コピーしました',
    open: 'リンクを開く',
    delete: '削除',
    scanAgain: 'もう一度スキャン',
    privacy: '処理はブラウザ内でローカルに実行されます。ファイルは端末外に送信されません。',
    upload: '画像をアップロード',
    paste: '貼り付け (Ctrl+V)',
    drop: 'ここに画像をドロップ',
    retry: '再試行',
    errorAccessDenied: 'カメラアクセス拒否',
    errorCamera: 'ブラウザ設定でカメラアクセスを許可してください。',
    initializing: 'カメラ初期化中...',
    cameraActive: 'カメラ起動中',
    scannedItems: 'スキャン結果',
    recentScans: '最近（ローカル保存）',
    clickToUpload: 'クリックしてアップロード',
    newBadge: 'NEW',
    tabCameraMobile: 'カメラ',
    tabCameraDesktop: 'カメラでスキャン',
    emptyState: { title: 'まだスキャンがありません', desc: '画像をアップロードするか、カメラタブで開始してください。' },
    highlights: {
      title: '高速・プライベートなスキャン',
      items: [
        { title: '端末内デコード', desc: 'アップロード不要。機密URLにも安心。' },
        { title: '複数形式', desc: 'QRに加えてUPC/EAN、Code 128、ITFなど対応。' },
        { title: '素早い操作', desc: 'ドラッグ&ドロップ、貼り付け、ライブスキャン切替。' },
        { title: 'モバイルに最適', desc: '小さな画面でも快適なUIとカメラフロー。' },
      ],
    },
    intro: { title: 'オンラインQR & バーコードスキャナー', body: 'アプリ不要でブラウザ内でQR/UPC/EANなどをデコードします。' },
    howTo: {
      title: 'スキャン方法',
      methods: [
        { title: '方法1：アップロード', steps: ['「画像をアップロード」をクリック', 'QR/バーコードを選択', '結果を確認'] },
        { title: '方法2：カメラ', steps: ['カメラタブを開く', '権限を許可', 'QR/バーコードにかざす'] },
      ],
    },
    features: {
      title: 'このスキャナーが選ばれる理由',
      items: [
        { title: 'ローカル履歴', desc: '最近のスキャンは端末内にのみ保存され、すぐ再利用できます。' },
        { title: 'オフライン画像デコード', desc: '画像のアップロード/貼り付けはオフラインでも動作します。' },
        { title: 'クイックアクション', desc: 'コピー/開く/削除を簡単に実行できます。' },
      ],
    },
    useCases: {
      title: 'よくある利用シーン',
      items: [
        { title: '小売・ショッピング', desc: '商品URL、クーポン、説明を確認。' },
        { title: '在庫管理', desc: 'バーコード確認と更新作業。' },
        { title: '日常利用', desc: 'メニュー、Wi‑Fi、連絡先をすばやく開く。' },
      ],
    },
    faq: {
      title: 'スキャナーFAQ',
      items: [
        { q: 'バーコードもスキャンできますか？', a: 'はい。QRに加えてCode 128、UPC、EAN、ITFなどに対応します。' },
        { q: 'スキャン結果を保存しますか？', a: 'スキャンは端末内に留まり、外部へ送信されません。' },
        { q: 'スクリーンショットを貼り付けできますか？', a: 'はい。Ctrl+V（Cmd+V）で貼り付けできます。' },
        { q: 'オフラインで使えますか？', a: '画像アップロードはオフラインで動作します。カメラは権限と対応ブラウザが必要です。' },
      ],
    },
  },
  blog: {
    title: '記事 & ガイド',
    subtitle: 'QR活用のベストプラクティス、マーケ施策、製品アップデート。',
    readMore: '続きを読む',
    back: 'ブログへ戻る',
    notFound: '記事が見つかりません',
  },
  common: {
    footer: 'マーケター、デザイナー、チーム向けの強力なQR作成スイート。',
    privacy: 'プライバシー',
    terms: '利用規約',
    contact: 'お問い合わせ',
    scanToOpen: 'モバイルで開くにはスキャン',
    help: 'ヘルプ',
    free: '無料',
    product: 'プロダクト',
    resources: 'リソース',
    company: '会社',
    api: 'API（近日公開）',
    systemStatus: '稼働中',
    footerDesc: '高度なQRコード生成＆スキャン。高速・プライバシー重視・永久無料（個人/商用）。',
  },
};

